import { gate } from 'hub-http/gates';
// v3 gates - https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage

export const RECOMMENDED_VIEW = gate('SSM:RecommendedView');
export const FTS_STAGED_USERS = gate('FTS:StagedUsers');
export const HUBSPOT_CREDITS = gate('HubSpotCredits');
export const INBOUND_25 = gate('SSM:Inbound25');
export const COMMERCE_HUB_INBOUND_25 = gate('SSM:CommerceHubInbound25');
export const PURCHASE_MOTION_CTA = gate('SSM:PurchaseMotionCTA');
export const REQUEST_PRODUCT_BUTTON = gate('GrowthEvaluation:EnableRequestAccessPurchaseMotion');
export const REMOVE_CHECKOUT_UTIL_REQUIRED_ONBOARDING_FALLBACK = gate('SSM:RemoveCheckoutRequiredOnboardingFallbackUtil');